import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20elegant%20abstract%20scene%20with%20soft%20rose%20gold%20and%20cream%20gradients%2C%20flowing%20organic%20shapes%2C%20gentle%20morning%20light%20diffused%20through%20translucent%20curtains%2C%20delicate%20floral%20silhouettes%2C%20dreamy%20atmospheric%20composition%2C%20emotional%20and%20serene%20mood%2C%20fine%20art%20photography%20style%20with%20soft%20focus&width=1800&height=900&seq=jiujiu-hero-01&orientation=landscape"
        alt="久久伊人 - 深情陪伴每一天"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40" />

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="animate-fadeInUp">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 md:mb-6 tracking-wider leading-tight">
            {heroData.title}
          </h1>
          <p className="text-sm md:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed mb-8 md:mb-10">
            {heroData.subtitle}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-7 py-3 rounded-md bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-primary-600"
            >
              {heroData.primaryCta}
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/articles"
              className="inline-flex items-center gap-2 px-7 py-3 rounded-md border border-white/40 text-white font-medium text-sm whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-white/10 hover:border-white/60"
            >
              {heroData.secondaryCta}
              <i className="ri-article-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}